/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const FlaskIconConfig = {
  name: 'FlaskIcon',
  height: 512,
  width: 448,
  svgPath: 'M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(FlaskIconConfig);